import { render, staticRenderFns } from "./ModeloCteDetalhes.vue?vue&type=template&id=372ab519"
import script from "./ModeloCteDetalhes.vue?vue&type=script&lang=js"
export * from "./ModeloCteDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports